// extracted by mini-css-extract-plugin
export default {"sideMenuItem":"SideMenuItem_sideMenuItem__euUVA","icon":"SideMenuItem_icon__I7eUa","menuLink":"SideMenuItem_menuLink__3vc9O","text":"SideMenuItem_text__yNT7J"};